import React, { useState, useEffect } from "react";
import PageTitle from "../../components/PageTitle";
import { Buttons } from "../../components/Buttons";
import "../listings/Pages.css";
import { DropDown, Calender } from "../../components/Forms";
import { Container, Row, Col, Table, Form, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { fetchCustomers } from "../../slice/CustomerSlice";
import {
  listCustomerHistory,
  fetchUnpaidReports,
  clearHistory,
} from "../../slice/GroupDataSlice";
import NotifyData from "../../components/NotifyData";
import { fetchCollections } from "../../slice/CollectionSlice";
import * as XLSX from "xlsx";
import Pagination from "../../components/Pagination";

const Report = () => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("recent");
  const [customerCode, setCustomerCode] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [selectedArea, setSelectedArea] = useState("");
  const [selectedStaff, setSelectedStaff] = useState("");
  const [selectedPlan, setSelectedPlan] = useState("");
  const { customers, areas, staff, plans, status, error } = useSelector(
    (state) => state.customers,
  );
  const { collections } = useSelector((state) => state.collections);
  const { history, unpaidReports } = useSelector((state) => state.groupData);
  const [filteredHistory, setFilteredHistory] = useState([]);
  const [filteredCollections, setFilteredCollections] = useState([]);
  const formatForAPI = (date) => date.toISOString().split("T")[0];

  // Keep these empty so the inputs show MM/DD/YYYY
  const [recentFromDate, setRecentFromDate] = useState("");
  const [recentToDate, setRecentToDate] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const recentItemsPerPage = 5;

  const loadUnpaidData = () => {
    dispatch(
      fetchUnpaidReports({
        plan_id: selectedPlan,
        area_id: selectedArea,
        staff_id: selectedStaff,
      }),
    );
  };

  useEffect(() => {
    if (activeTab === "unpaid") {
      loadUnpaidData();
    }
  }, [activeTab]);

  useEffect(() => {
    setCurrentPage(1);
  }, [activeTab, selectedArea, selectedStaff, selectedPlan, dateFrom, dateTo]);

  const indexOfLastCollection = currentPage * itemsPerPage;
  const indexOfFirstCollection = indexOfLastCollection - itemsPerPage;
  const currentCollections = filteredCollections.slice(
    indexOfFirstCollection,
    indexOfLastCollection,
  );
  const totalCollectionPages = Math.ceil(
    filteredCollections.length / itemsPerPage,
  );

  // --- Unpaid Pagination Logic ---
  const indexOfLastUnpaid = currentPage * itemsPerPage;
  const indexOfFirstUnpaid = indexOfLastUnpaid - itemsPerPage;
  const currentUnpaid = unpaidReports.slice(
    indexOfFirstUnpaid,
    indexOfLastUnpaid,
  );
  const totalUnpaidPages = Math.ceil(unpaidReports.length / itemsPerPage);


  const indexOfLastHistory = currentPage * recentItemsPerPage;
const indexOfFirstHistory = indexOfLastHistory - recentItemsPerPage;
const currentHistorySlice = filteredHistory.slice(indexOfFirstHistory, indexOfLastHistory);
const totalHistoryPages = Math.ceil(filteredHistory.length / recentItemsPerPage);

  const handleDownloadExcel = () => {
    // Format for Excel
    const excelData = filteredCollections.map((c, index) => ({
      SNo: index + 1,
      "Payment Date": new Date(c.collection_paid_date).toLocaleDateString(
        "en-GB",
      ),
      "Customer No": c.customer_no,
      "Customer Name": c.name,
      "Assign Staff Name": c.staff_name,
      "Area Name": c.area_name,
      "Plan Name": c.plan_name,
      "Plan Price": c.plan_prize,
      // "Box No": c.box_no,
      "Box No": c.box_no ? String(c.box_no) : "",
      "Total Amount": c.total_pending_amount,
      "Collection Amount": c.entry_amount,
      "Balance Amount": c.balance_amount,
      "Paid By": c.paid_by_name,
      "Payment Method": c.payment_method,
    }));

    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Collection Report");

    // Generate filename based on filters
    const today = new Date();
    let filename = "Collection_Report";
    if (dateFrom) filename += `_From_${dateFrom}`;
    if (dateTo) filename += `_To_${dateTo}`;
    if (selectedArea) {
      const areaName =
        areas.find((a) => a.area_id === selectedArea)?.area_name || "Area";
      filename += `_${areaName.replace(/\s+/g, "_")}`;
    }
    if (selectedStaff) {
      const staffName =
        staff.find((s) => s.staff_id === selectedStaff)?.staff_name || "Staff";
      filename += `_${staffName.replace(/\s+/g, "_")}`;
    }
    filename += `_${today.getFullYear()}.xlsx`;

    // Download file
    XLSX.writeFile(wb, filename);
  };

  const handleDownloadUnpaidExcel = () => {
    if (unpaidReports.length === 0) {
      alert("No data available to download");
      return;
    }

    // Map the unpaidReports data to match the table columns
    const excelData = unpaidReports.map((item, index) => ({
      "S.No": index + 1,
      "Customer No": item.customer_no,
      "Customer Name": item.name,
      "Area Name": item.area_name || "-",
      "Staff Name": item.staff_name,
      "Plan Name": item.plan_name,
    }));

    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Unpaid Report");

    // Generate filename with current date
    const today = new Date().toISOString().split("T")[0];
    XLSX.writeFile(wb, `Unpaid_Report_${today}.xlsx`);
  };
  useEffect(() => {
    dispatch(fetchCustomers());
    dispatch(fetchCollections());
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    dispatch(
      listCustomerHistory({
        from_date: formatForAPI(yesterday),
        to_date: formatForAPI(today),
        customer_no: "",
      }),
    );
  }, [dispatch]);

  useEffect(() => {
    setFilteredHistory(history);
  }, [history]);

  // Filter collections for the Collection Report tab
  useEffect(() => {
    let filtered = collections;

    if (collections && collections.length > 0) {
      console.log("Full First Row:", collections[0]);
      console.log("Box No Value:", collections[0].box_no);
      console.log("Box No Type:", typeof collections[0].box_no);
    }

    if (dateFrom) {
      filtered = filtered.filter(
        (c) => new Date(c.collection_paid_date) >= new Date(dateFrom),
      );
    }
    if (dateTo) {
      filtered = filtered.filter(
        (c) => new Date(c.collection_paid_date) <= new Date(dateTo),
      );
    }
    if (selectedArea) {
      filtered = filtered.filter((c) => c.area_id === selectedArea);
    }
    if (selectedStaff) {
      filtered = filtered.filter((c) => c.staff_id === selectedStaff);
    }

    setFilteredCollections(filtered);
  }, [collections, dateFrom, dateTo, selectedArea, selectedStaff]);

  // Function to format object values for display
  const formatValue = (value, actionType) => {
    if (!value) return <span className="text-muted">None</span>;

    // Define fields to display based on action type
    const isCollection = actionType.includes("collection");
    const fields = isCollection
      ? [
          { key: "customer_no", label: "Customer No" },
          { key: "name", label: "Customer Name" },
          { key: "phone", label: "Phone" },
          { key: "area_name", label: "Area Name" },
          { key: "plan_name", label: "Plan Name" },
          { key: "plan_prize", label: "Plan Price" },
          { key: "staff_name", label: "Staff Name" },
          { key: "collection_paid_date", label: "Payment Date" },
          { key: "entry_amount", label: "Collection Amount" },
          { key: "balance_amount", label: "Balance Amount" },
          { key: "payment_method", label: "Payment Method" },
        ]
      : [
          { key: "customer_no", label: "Customer No" },
          { key: "name", label: "Customer Name" },
          { key: "phone", label: "Phone" },
          { key: "area_name", label: "Area Name" },
          { key: "plan_name", label: "Plan Name" },
          { key: "plan_prize", label: "Plan Price" },
          { key: "staff_name", label: "Staff Name" },
          { key: "total_pending_amount", label: "Total Pending Amount" },
          { key: "total_due_amount", label: "Total Due Amount" },
        ];

    return (
      <div className="value-container">
        {fields.map((field) => (
          <div key={field.key} className="value-row">
            <span className="value-label">{field.label}:</span>
            <span className="value-content">
              {value[field.key]
                ? field.key.includes("date")
                  ? new Date(value[field.key]).toLocaleDateString("en-GB")
                  : value[field.key]
                : "-"}
            </span>
          </div>
        ))}
      </div>
    );
  };

  // Reset filters
  const handleReset = () => {
    setDateFrom("");
    setDateTo("");
    setSelectedArea("");
    setSelectedStaff("");
    setCustomerCode("");
    setSelectedPlan("");
  };

  return (
    <div id="main">
      <Container fluid>
        <Row>
          <Col xs="12" className="py-3">
            <PageTitle PageTitle="Reports" showButton={false} />
          </Col>

          {/* Tab Buttons */}
          <Col lg="6" xs="12" className="py-3 d-flex gap-3 report-tabs">
            <Buttons
              btnlabel="Recent Activities"
              className={`${
                activeTab === "recent" ? "active-tab-btn" : "inactive-tab-btn"
              }`}
              onClick={() => setActiveTab("recent")}
            />
            <Buttons
              btnlabel="Collection Report"
              className={`${
                activeTab === "collection"
                  ? "active-tab-btn"
                  : "inactive-tab-btn"
              }`}
              onClick={() => setActiveTab("collection")}
            />
            <Buttons
              btnlabel="Unpaid Report"
              className={`${
                activeTab === "unpaid" ? "active-tab-btn" : "inactive-tab-btn"
              }`}
              onClick={() => setActiveTab("unpaid")}
            />
          </Col>

          {/* Recent Activities Tab */}
         {activeTab === "recent" && (
  <Col xs="12" className="py-3">
    <Container fluid className="p-4">
      <Row className="align-items-end">
        <Col lg="2" className="my-2">
          <Calender
            calenderlabel="From Date"
            initialDate={recentFromDate}
            setLabel={setRecentFromDate}
          />
        </Col>
        <Col lg="2" className="my-2">
          <Calender
            calenderlabel="To Date"
            initialDate={recentToDate}
            setLabel={setRecentToDate}
          />
        </Col>
        <Col lg="3" className="my-2">
          <DropDown
            textlabel="Customer No"
            value={customerCode}
            onChange={(e) => setCustomerCode(e.target.value)}
            options={
              customers.length > 0
                ? customers.map((customer) => ({
                    value: customer.customer_no,
                    label: `${customer.customer_no} (${customer.name})`,
                  }))
                : [{ value: "", label: "Loading..." }]
            }
          />
        </Col>
        <Col lg="4" className="d-flex gap-4 mb-2">
          <Button
            variant="success"
            className="px-4"
            onClick={() => {
              setCurrentPage(1); // Reset to page 1 on new filter
              dispatch(
                listCustomerHistory({
                  customer_no: customerCode,
                  from_date: recentFromDate,
                  to_date: recentToDate,
                }),
              );
            }}
          >
            Apply Filter
          </Button>

          <Button
            variant="secondary"
            onClick={() => {
              setRecentFromDate("");
              setRecentToDate("");
              setCustomerCode("");
              setCurrentPage(1); // Reset to page 1

              const today = new Date();
              const yesterday = new Date();
              yesterday.setDate(yesterday.getDate() - 1);

              dispatch(
                listCustomerHistory({
                  from_date: formatForAPI(yesterday),
                  to_date: formatForAPI(today),
                }),
              );
            }}
          >
            Undo Filter
          </Button>
        </Col>

        <Col lg="12">
          {status === "loading" && <p>Loading...</p>}
          {status === "failed" && (
            <NotifyData message={error} type="error" />
          )}
          <Table bordered hover striped responsive className="mt-4 mb-0">
            <thead className="table-secondary">
              <tr>
                <th className="recent_activities_heading">S.No</th>
                <th className="recent_activities_heading">Date</th>
                <th className="recent_activities_heading">History Type</th>
                <th className="recent_activities_heading">Old Value</th>
                <th className="recent_activities_heading">New Value</th>
                <th className="recent_activities_heading">Remark</th>
              </tr>
            </thead>
            <tbody>
              {currentHistorySlice.length > 0 ? (
                currentHistorySlice.map((history, index) => (
                  <tr key={history.id || index}>
                    {/* Continuous S.No based on current page */}
                    <td>{indexOfFirstHistory + index + 1}</td>
                    <td>
                      {history.created_at
                        ? new Date(history.created_at).toLocaleDateString("en-GB")
                        : "-"}
                    </td>
                    <td>{history.action_type}</td>
                    <td>
                      {formatValue(
                        history.old_value,
                        history.action_type,
                      )}
                    </td>
                    <td>
                      {formatValue(
                        history.new_value,
                        history.action_type,
                      )}
                    </td>
                    <td>{history.remarks}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={6} className="text-center">
                    No recent activities found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          {/* Pagination Component */}
          {filteredHistory.length > 0 && (
            <div className="p-3 d-flex justify-content-end">
              <Pagination
                currentPage={currentPage}
                totalPages={totalHistoryPages}
                onPageChange={setCurrentPage}
              />
            </div>
          )}
        </Col>
      </Row>
    </Container>
  </Col>
)}

          {/* Collection Report Tab */}
          {/* Collection Report Tab */}
          {activeTab === "collection" && (
            <Container fluid className="p-3">
              {/* Filters */}
              <Row className="mb-3">
                <Col md={3} className="my-2">
                  <Calender
                    calenderlabel="From Date"
                    initialDate={dateFrom}
                    setLabel={setDateFrom}
                  />
                </Col>

                <Col md={3} className="my-2">
                  <Calender
                    calenderlabel="To Date"
                    initialDate={dateTo}
                    setLabel={setDateTo}
                  />
                </Col>

                <Col md={3} className="my-2">
                  <DropDown
                    textlabel="Select Area"
                    value={selectedArea}
                    onChange={(e) => setSelectedArea(e.target.value)}
                    options={[
                      { value: "", label: "All Areas" },
                      ...areas.map((area) => ({
                        value: area.area_id,
                        label: area.area_name,
                      })),
                    ]}
                  />
                </Col>

                <Col md={3} className="my-2">
                  <DropDown
                    textlabel="Select Staff"
                    value={selectedStaff}
                    onChange={(e) => setSelectedStaff(e.target.value)}
                    options={[
                      { value: "", label: "All Staff" },
                      ...staff.map((s) => ({
                        value: s.staff_id,
                        label: s.staff_name,
                      })),
                    ]}
                  />
                </Col>

                <Col md={3} className="d-flex align-items-end gap-2 py-3">
                  <Button variant="secondary" onClick={handleReset}>
                    Reset Filters
                  </Button>
                  <Button variant="success" onClick={handleDownloadExcel}>
                    Download Excel
                  </Button>
                </Col>
              </Row>

              {/* Table */}
              <Row>
                <Col>
                  <Table bordered hover responsive className="mb-0">
                    <thead className="table-secondary">
                      <tr>
                        <th className="collection_report_heading">S.No</th>
                        <th className="collection_report_heading">
                          Payment Date
                        </th>
                        <th className="collection_report_heading">
                          Customer No
                        </th>
                        <th className="collection_report_heading">
                          Customer Name
                        </th>
                        <th className="collection_report_heading">
                          Assign Staff Name
                        </th>
                        <th className="collection_report_heading">Area Name</th>
                        <th className="collection_report_heading">Plan Name</th>
                        <th className="collection_report_heading">
                          Plan Price
                        </th>
                        <th className="collection_report_heading">Box No</th>
                        <th className="collection_report_heading">
                          Total Amount
                        </th>
                        <th className="collection_report_heading">
                          Collection Amount
                        </th>
                        <th className="collection_report_heading">
                          Balance Amount
                        </th>
                        <th className="collection_report_heading">Paid By</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentCollections.length > 0 ? (
                        currentCollections.map((collection, index) => (
                          <tr key={collection.collection_id || index}>
                            {/* Serial number continues across pages */}
                            <td>{indexOfFirstCollection + index + 1}</td>
                            <td>
                              {collection.collection_paid_date
                                ? new Date(
                                    collection.collection_paid_date,
                                  ).toLocaleDateString("en-GB")
                                : "-"}
                            </td>
                            <td>{collection.customer_no}</td>
                            <td>{collection.name}</td>
                            <td>{collection.staff_name}</td>
                            <td>{collection.area_name}</td>
                            <td>{collection.plan_name}</td>
                            <td>{collection.plan_prize}</td>
                            <td>
                              {collection.box_no
                                ? String(collection.box_no)
                                : "-"}
                            </td>
                            <td>{collection.total_pending_amount}</td>
                            <td>{collection.entry_amount}</td>
                            <td>{collection.balance_amount}</td>
                            <td>{collection.paid_by_name}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={13} className="text-center">
                            No collections found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>

                  {/* Pagination Controls */}
                  {filteredCollections.length > 0 && (
                    <div className="p-3 d-flex justify-content-end">
                      <Pagination
                        currentPage={currentPage}
                        totalPages={totalCollectionPages}
                        onPageChange={setCurrentPage}
                      />
                    </div>
                  )}
                </Col>
              </Row>
            </Container>
          )}

          {/* Unpaid Report Tab */}
          {/* Unpaid Report Tab */}
          {activeTab === "unpaid" && (
            <Container fluid className="p-3">
              {/* Filters */}
              <Row className="mb-3 align-items-end">
                <Col md={2} className="my-2">
                  <DropDown
                    textlabel="Select Area"
                    value={selectedArea}
                    onChange={(e) => setSelectedArea(e.target.value)}
                    options={[
                      { value: "", label: "All Areas" },
                      ...areas.map((area) => ({
                        value: area.area_id,
                        label: area.area_name,
                      })),
                    ]}
                  />
                </Col>

                <Col md={2} className="my-2">
                  <DropDown
                    textlabel="Select Staff"
                    value={selectedStaff}
                    onChange={(e) => setSelectedStaff(e.target.value)}
                    options={[
                      { value: "", label: "All Staff" },
                      ...staff.map((s) => ({
                        value: s.staff_id,
                        label: s.staff_name,
                      })),
                    ]}
                  />
                </Col>
                <Col md={2} className="my-2">
                  <DropDown
                    textlabel="Select Plan"
                    value={selectedPlan}
                    onChange={(e) => setSelectedPlan(e.target.value)}
                    options={[
                      { value: "", label: "All Plans" },
                      ...plans.map((p) => ({
                        value: p.plan_id,
                        label: p.plan_name,
                      })),
                    ]}
                  />
                </Col>

                <Col md={6} className="my-2 d-flex gap-2 align-items-end">
                  <Button
                    className="px-4"
                    variant="success"
                    onClick={loadUnpaidData}
                  >
                    Apply Filter
                  </Button>
                  <Button variant="secondary" onClick={handleReset}>
                    Reset Filters
                  </Button>
                  <Button variant="success" onClick={handleDownloadUnpaidExcel}>
                    Download Excel
                  </Button>
                </Col>
              </Row>

              {/* Table */}
              <Row>
                <Col>
                  <Table bordered hover responsive className="mb-0">
                    <thead className="table-secondary">
                      <tr>
                        <th>S.No</th>
                        <th>Customer No</th>
                        <th>Customer Name</th>
                        <th>Area Name</th>
                        <th>Staff Name</th>
                        <th>Plan Name</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentUnpaid.length > 0 ? (
                        currentUnpaid.map((item, index) => (
                          <tr key={item.id || index}>
                            {/* Serial number logic for current page */}
                            <td>{indexOfFirstUnpaid + index + 1}</td>
                            <td>{item.customer_no}</td>
                            <td>{item.name}</td>
                            <td>{item.area_name || "-"}</td>
                            <td>{item.staff_name}</td>
                            <td>{item.plan_name}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={6} className="text-center">
                            {status === "loading"
                              ? "Loading..."
                              : "No unpaid records found"}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>

                  {/* Pagination Controls */}
                  {unpaidReports.length > 0 && (
                    <div className="p-3 d-flex justify-content-end">
                      <Pagination
                        currentPage={currentPage}
                        totalPages={totalUnpaidPages}
                        onPageChange={setCurrentPage}
                      />
                    </div>
                  )}
                </Col>
              </Row>
            </Container>
          )}
        </Row>
      </Container>
    </div>
  );
};

export default Report;
